import { useEffect, useRef, useState } from "react";

const comparisons = [
  { traditional: "Photo-based matching", aurays: "Personality + behaviour" },
  { traditional: "Endless chatting", aurays: "Real-life meetings" },
  { traditional: "Low accountability", aurays: "Reputation system" },
  { traditional: "Random matching", aurays: "Interest-based communities" },
];

export default function ComparisonSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#FAFAF9] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-xs font-semibold text-[#7C55CC] uppercase tracking-widest mb-3">The Difference</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Aurays is different
          </h2>
          <p className="text-gray-500 text-base max-w-md mx-auto leading-relaxed">
            Dating shouldn't feel like a job interview. It should feel natural — like meeting someone through life.
          </p>
        </div>

        <div className={`transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {/* Table Header */}
          <div className="grid grid-cols-2 mb-3 px-6">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest">Traditional Apps</p>
            <p className="text-xs font-semibold text-[#7C55CC] uppercase tracking-widest">Aurays</p>
          </div>

          {/* Table Rows */}
          <div className="flex flex-col gap-3">
            {comparisons.map((row, i) => (
              <div
                key={i}
                className="grid grid-cols-2 bg-white rounded-2xl overflow-hidden border border-gray-100"
              >
                <div className="px-6 py-4 flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-close-line text-gray-300 text-lg"></i>
                  </div>
                  <span className="text-sm text-gray-400">{row.traditional}</span>
                </div>
                <div className="px-6 py-4 flex items-center gap-3 bg-[#F5F0FF]">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#7C55CC] text-lg"></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-800">{row.aurays}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
